import {
  SchemaDefinition,
  SchemaTransformError,
  UnknownSchema,
  ViewModel
} from '@rehaje/core'

import type { URLParameterSpecific } from './TypedNode'

export interface SchemaURLParameterSpecific extends RehajeSchemaMetadata {
  /**
   * URLParameter 默认配置
   */
  default?: URLParameterSpecific
  type: 'Schema.URLParameter'
  /**
   * 值
   */
  value?: any
}

export class SchemaURLParameterDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaURLParameterSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaURLParameterSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(
    target: any,
    schema: SchemaURLParameterSpecific
  ): SchemaURLParameterSpecific {
    return { ...this.inferOnlySchema(schema), value: target }
  }

  override inferOnlySchema(schema: SchemaURLParameterSpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaURLParameterSpecific): string {
    if (schema.value instanceof ViewModel)
      return super.inferShapeTypeScript(schema.value)
    return this.interface
  }

  override prune(target: any): any {
    return target
  }

  override transform(
    target: any,
    schema: SchemaURLParameterSpecific,
    path: PropertyKey[] = []
  ) {
    if (this.test(target, schema, path)) return target
    if (target !== schema.fallback)
      this.raise(new SchemaTransformError(schema.name))
    return target
  }

  override validate(target: any, schema: SchemaURLParameterSpecific) {
    this.validateMetadata(target, schema, (target) => {
      return typeof target === 'function' || this.isRelationSpecific(target)
    })
  }
}

declare global {
  export interface RehajeSpecifics {
    'Schema.URLParameter': SchemaURLParameterSpecific
  }
}
